<template>
  <div class="div-home">
    <div class="div-count-title">
      <span class="span-count-tip">距离目标还差</span>
      <span class="span-count-number">{{remainNum}}</span>
      <span class="span-count-tip">个</span>
    </div>
    <ul class="ul-word">
      <li v-for="(item, index) in wordlist" :key="index" :class='index % 2 == 0 ? "even li-word" : "odd li-word"'>
        <span class="span-word-index">{{index + 1}}. </span>
        <span class="span-word-content">{{item.word}}</span>
        <span class="span-word-delete" @click="deleteWord(item.word)">x</span>
      </li>
    </ul>
    <div class="div-add-button" @click="add">
      <span class="span-add">添加</span>
    </div>
    <AddDialog
      :show="showAddDialog"
      v-on:closeDialog="closeDialog(show)"
      v-on:commit="commit"
    ></AddDialog>
  </div>
</template>

<script>
import funwordApi from "../api/funwordApi"
import AddDialog from "../components/AddDialog"

export default {
  name: 'Home',
  components: {
    AddDialog
  },
  data() {
    return {
      maxNum: 8000,
      remainNum: 0,
      wordlist: [],
      showAddDialog: false
    }
  },
  methods: {
    requestAllWords() {
      let self = this
      funwordApi.allwords({})
          .then(data => {
            self.wordlist = data.data.dataList
            let length = self.wordlist.length
            self.remainNum = (length > self.maxNum ? 0 : self.maxNum - length)
            console.log(self.wordlist)
          })
    },
    closeDialog (show) {
      this.showAddDialog = show
    },
    commit () {
      this.showAddDialog = false
      this.requestAllWords()
    },
    deleteWord (word) {
      funwordApi.deleteword({word: word})
          .then(() => {
            this.requestAllWords()
          })
    },
    add () {
      this.showAddDialog = true
    }
  },
  mounted() {
  },
  created() {
    this.requestAllWords()
  }
}
</script>

<style scoped>
.div-home {
  width: 100%;
  position: relative;
}
.div-count-title {
  margin-left: 15px;
  height: 50px;
}
.span-count-tip {
  line-height: 50px;
  color: gray;
}
.span-count-number {
  font-size: 36px;
  font-weight: bold;
  color: purple;
}
.ul-word {
}
.li-word {
  height: 30px;
  line-height: 30px;
  padding-left: 15px;
}
.even {
  background: #efefef;
}
.odd {
  background: #fefefe;
}
.span-word-index {
  color: gray;
}
.span-word-content {
  color: black;
  font-weight: bold;
  display: inline-block;
}
.span-word-delete {
  width: 20px;
  height: 20px;
  background-color: red;
  color: white;
  border-radius: 10px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 10px;
}
.div-add-button {
  position: fixed;
  width: 50px;
  height: 50px;
  z-index: 100;
  bottom: 20px;
  right: 20px;
  border-radius: 30px;
  background-color: #38a2ff;
  text-align: center;
}
.span-add {
  line-height: 50px;
  color: white;
  font-size: 12px;
}
</style>
